// extracted by mini-css-extract-plugin
module.exports = {"parents":"styles-module--parents--1E8xY","container":"styles-module--container--1Jxnm","block":"styles-module--block--3WZ0p"};